import React from 'react';
import { KanoPredictionResult } from '../ai/useKanoPrediction';
import { FeatureModel } from '../interfaces/feature';
import { StepContainerItem1 } from './components/StepContainerItem1';
import { StepContainerItem2 } from './components/StepContainerItem2';
import { StepContainerItem3 } from './components/StepContainerItem3';
import { StepContainerItem4 } from './components/StepContainerItem4';

export const Home: React.FC = () => {
  const [currentStep, setCurrentStep] = React.useState<number>(0);
  const [productInformation, setProductInformation] = React.useState<string>('');
  const [features, setFeatures] = React.useState<FeatureModel[]>([]);
  const [prediction, setPrediction] = React.useState<KanoPredictionResult | null>(null);

  const showNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const showPreviousStep = () => {
    setCurrentStep(Math.max(currentStep - 1, 0));
  };

  return (
    <>
      {currentStep === 0 && (
        <StepContainerItem1
          onNextClicked={productInformation => {
            setProductInformation(productInformation);
            showNextStep();
          }}
        />
      )}
      {currentStep === 1 && (
        <StepContainerItem2
          onPreviousClicked={showPreviousStep}
          onNextClicked={features => {
            setFeatures(features);
            showNextStep();
          }}
        />
      )}
      {currentStep === 2 && (
        <StepContainerItem3
          features={features}
          productInformation={productInformation}
          onPredictionReady={prediction => {
            setPrediction(prediction);
            showNextStep();
          }}
        />
      )}
      {currentStep === 3 && <StepContainerItem4 result={prediction} />}
    </>
  );
};
